import React, { useEffect, useState } from 'react';
import './RecentTable.css'
import RTableRow from './RTableRow';
import { supabase } from '../../supabase';

const RecentEventsTable = (props) => {

    const [events, setEvents] = useState([]);

    useEffect(()=>{
            const getEvents = async () => {
                const res = await supabase.from('Events').select(`*`);
                setEvents(res.data);
                console.log(res.data)
            }
    
            getEvents();
        } , [])

    return ( <div className='RecentTable'>
        <p className='RTableName'>
            {props.RTableName}
        </p>

        <div className='RTableRows'>
            {
                events.map((item)=>{
                   return <RTableRow key={item.id} RowName={item.event_Name} RowSub={item.event_Loc} RowInfo={item.tickets_Sold + '/2000 sold'} RowTag={item.status} TagStyle='Confirmed'/>
                })
            }
        </div>
    </div> );
}
 
export default RecentEventsTable;
